import { render, staticRenderFns } from "./TextareaV1.vue?vue&type=template&id=5ffed889&scoped=true&"
import script from "./TextareaV1.vue?vue&type=script&lang=js&"
export * from "./TextareaV1.vue?vue&type=script&lang=js&"
import style0 from "./TextareaV1.vue?vue&type=style&index=0&id=5ffed889&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffed889",
  null
  
)

export default component.exports